// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"cef38052","435":"233cd53a","453":"ca645700","583":"e4633ea1"}[chunkId] + ".chunk.js";
};